<body class="ltr  leftmenu">
    <form autocomplete="off" novalidate [formGroup]="TranscriptForm">
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <div class=" d-flex align-items-center pl-3">
                                                <!-- <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                    class="mh-45px pb-2"> -->
                                                <div>
                                                    <h3 class="main-content-label mb-1"><b>
                                                            Transcript Certificate
                                                        </b></h3>
                                                    <!-- <p class="text-muted card-sub-title mb-0">
                                                        complaint-form works!
                                                    </p> -->
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                    <hr class="mt-2">

                                    <div class="row">

                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Applicant's Full Name</mat-label>
                                                        <input readonly formControlName="StuName" matInput
                                                            placeholder="Applicant's Full Name" class="color">
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Course </mat-label>
                                                        <mat-select disabled #select343 placeholder="CoCode"
                                                            class="color" formControlName="StuCourse">
                                                            <mat-select-filter *ngIf="select343.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="courseList"
                                                                (filteredReturn)=" filteredCourseList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCourseList"
                                                                [value]="item.CoCode">
                                                                {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Date Of Admission</mat-label>
                                                        <input readonly formControlName="AdmDate" matInput
                                                            [value]="TranscriptForm.controls['AdmDate'].value | date: 'dd/MM/yyyy'"
                                                            placeholder="Date Of Admission" class="color">
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Name Of The College </mat-label>
                                                        <mat-select disabled #select384 class="color"
                                                            formControlName="StuClg">
                                                            <mat-select-filter *ngIf="select384.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="CollegeList"
                                                                (filteredReturn)=" filteredCollegeList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredCollegeList"
                                                                [value]="item.CgCode">
                                                                {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3 fs1">
                                            <!-- <div class="form-group" *ngIf="PreFix != ''">
                                                <mat-form-field appearance="outline"
                                                    class="example-full-width">
                                                    <mat-label>RegnNo/PRN No. </mat-label>

                                                    <input readonly matInput value="{{ PreFix + ' / ' + formattedPrn }}"
                                                        placeholder="RegNo/PRN No" maxlength="10">
                                                </mat-form-field>
                                            </div> -->
                                            <!-- <div class="form-group" *ngIf="PreFix == ''">
                                                <mat-form-field appearance="outline"
                                                    class="example-full-width">
                                                    <mat-label>RegnNo/PRN No. </mat-label>

                                                    <input readonly matInput value="{{RegnNo}}"
                                                        placeholder="RegNo/PRN No" maxlength="10">
                                                </mat-form-field>
                                            </div> -->
                                            <div class="wml" *ngIf="PreFix != ''">
                                                <p class="p10">Rg No. (M.U.H.S):{{PreFix}}/{{formattedPrn}}</p>
                                            </div>
                                            <div class="wml" *ngIf="PreFix == '' ">
                                                <p class="p10">Rg No. (M.U.H.S):{{formattedPrn}}</p>
                                            </div>
                                        </div>
                                        <div class="col-sm-3 fs1">
                                            <p>Internship Completion Period :</p>
                                        </div>
                                        <div class="col-sm-3 ml22">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline"
                                                        class="calsz example-full-width">
                                                        <mat-label>From Date</mat-label>
                                                        <input class="color datehgt" matInput
                                                            [matDatepicker]="pickerFrom" placeholder="FromDate"
                                                            formControlName="StuFromDate" [min]="minDate">
                                                        <!-- (dateChange)="HolidayDate(i)" -->
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="pickerFrom"></mat-datepicker-toggle>
                                                        <mat-datepicker #pickerFrom></mat-datepicker>
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TranscriptForm.controls['StuFromDate'].touched && TranscriptForm.controls['StuFromDate'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TranscriptForm.controls['StuFromDate'].hasError('matDatepickerMin')">
                                                            Date cannot be before {{ minDate | date:'MM/dd/yyyy' }}
                                                        </mat-error>
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TranscriptForm.controls['StuFromDate'].hasError('invalidYear')">
                                                            Enter a valid date (YYYY-MM-DD)
                                                        </mat-error>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline"
                                                        class="hgt calsz example-full-width">
                                                        <mat-label>To Date</mat-label>
                                                        <input class="color datehgt" matInput [matDatepicker]="pickerTo"
                                                            placeholder="ToDate" formControlName="StuToDate"
                                                            [min]="minDate">
                                                        <!-- (dateChange)="HolidayDate(i)" -->
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="pickerTo"></mat-datepicker-toggle>
                                                        <mat-datepicker #pickerTo></mat-datepicker>
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TranscriptForm.controls['StuToDate'].touched && TranscriptForm.controls['StuToDate'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TranscriptForm.controls['StuToDate'].hasError('matDatepickerMin')">
                                                            Date cannot be before {{ minDate | date:'MM/dd/yyyy' }}
                                                        </mat-error>
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TranscriptForm.controls['StuToDate'].hasError('invalidYear')">
                                                            Enter a valid date (YYYY-MM-DD)
                                                        </mat-error>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Council Registration Number</mat-label>
                                                    <input formControlName="CouncilRegNo" matInput
                                                        placeholder="Council Registration Number" maxlength="10">
                                                    <mat-error class="margin_tp sz float-left"
                                                        *ngIf="TranscriptForm.controls['CouncilRegNo'].touched && TranscriptForm.controls['CouncilRegNo'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                </mat-form-field>

                                            </div>
                                        </div>

                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Phone Number</mat-label>
                                                    <input readonly formControlName="StuPhone" matInput
                                                        placeholder="Council Registration Number">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Email</mat-label>
                                                    <input readonly formControlName="StuEmail" matInput
                                                        placeholder="Council Registration Number">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Address For Correspondence</mat-label>
                                                    <input readonly formControlName="StuAdd" matInput
                                                        placeholder="Council Registration Number">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>PinCode</mat-label>
                                                    <input readonly formControlName="StuPin" matInput
                                                        placeholder="Council Registration Number">
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="col-sm-3" >
                                            <div class="form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Number of Additional Sets Of Certified Copies Of
                                                        Transcript Required</mat-label>
                                                    <input  [readonly]="isdisabled"
                                                        matTooltip="Number of Additional Sets Of Certified Copies Of Transcript Required"
                                                        formControlName="StuCertCopies" matInput maxlength="2"
                                                        placeholder="Number of Additional Sets Of Certified Copies Of Transcript Required">
                                                    <mat-error class="margin_tp sz float-left"
                                                        *ngIf="TranscriptForm.controls['StuCertCopies'].touched && TranscriptForm.controls['StuCertCopies'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                </mat-form-field>

                                            </div>
                                        </div>

                                        <!-- Foreign university radio button -->
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <div class="row fs1">
                                                        <div class="col-sm-7 mt-2">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>Apply for Foreign University?</mat-label>
                                                        </div>
                                                        <div class="col-sm-6 ml27">
                                                            <mat-radio-group 
                                                                formControlName="ForeignUni" class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-6 mt-2">
                                                                        <mat-radio-button value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-5 mt-2">
                                                                        <mat-radio-button value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                                <mat-error class="margin_tp sz2 float-left"
                                                                    *ngIf="TranscriptForm.controls['ForeignUni'].touched && TranscriptForm.controls['ForeignUni'].errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
    
                                                </div>
                                            </div>
                                            
                                        </div>

                                        <!-- Foreign university details if selected-->

                                        <div class="col-sm-3" *ngIf="TranscriptForm.get('ForeignUni').value == 'Y'">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>University Name</mat-label>
                                                        <input formControlName="UniName" matInput
                                                            placeholder="University Name " class="color">
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TranscriptForm.controls['UniName'].touched && TranscriptForm.controls['UniName'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4" *ngIf="TranscriptForm.get('ForeignUni').value == 'Y'">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>University Address</mat-label>
                                                        <!-- <input formControlName="UniAddress" matInput
                                                            placeholder="University Address " class="color"> -->
                                                        <textarea matInput formControlName="UniAddress" rows="4" cols="2" placeholder="Enter text"></textarea>
                                                        
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TranscriptForm.controls['UniAddress'].touched && TranscriptForm.controls['UniAddress'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                        </div>
                                        <!-- WES Checkbox  -->

                                        <!-- <div class="col-sm-3" *ngIf="TranscriptForm.get('ForeignUni').value == 'Y'">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Equivalence  Provider</mat-label>
                                                        <mat-select #select384 class="color"
                                                            formControlName="IsWES">
                                                            <mat-select-filter *ngIf="select384.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdCode'"
                                                                [array]="applyUniversity"
                                                                (filteredReturn)=" filteredapplyUniversity =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredapplyUniversity"
                                                                [value]="item.CdCode" (click)="onDrpChange(item)" >
                                                                {{item.CdCode}} - {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                        </div> -->
                                        <!-- WES Details if selected -->
                                        <div *ngIf="TranscriptForm.get('ForeignUni').value == 'Y'">
                                            <table class="table table-bordered text-nowrap text-left">
                                                <thead>
                                                    <tr class="text-left">
                                                        <th class="f600" style="width: 20%;">
                                                            Equivalence Provider
                                                        </th>
                                                        <th class="f600" style="width: 20%;">
                                                            Document Name
                                                        </th>
                                                        <th class="f600 " style="width: 20%;">
                                                            Reference Number
                                                        </th>
                                                        <th class="f600 " style="width: 20%;">
                                                            Document Upload
                                                        </th>
                                                        <th style="width: 10%;" *ngIf="DocView">
                                                            View
                                                        </th>

                                                    </tr>
                                                </thead>
                                                <tbody id="table_data">
                                                    <tr>
                                                        <td>
                                                            <mat-form-field appearance="outline" class="example-full-width">
                                                                <mat-label> Equivalence  Provider</mat-label>
                                                                <mat-select #select384 class="color"
                                                                    formControlName="IsWES">
                                                                    <mat-select-filter *ngIf="select384.focused"
                                                                        [placeholder]="'Filter'" [displayMember]="'CdCode'"
                                                                        [array]="applyUniversity"
                                                                        (filteredReturn)=" filteredapplyUniversity =$event"></mat-select-filter>
                                                                    <mat-option *ngFor="let item of  filteredapplyUniversity"
                                                                        [value]="item.CdCode" (click)="onDrpChange(item)" >
                                                                        {{item.CdCode}} - {{item.CdDesc}}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>
                                                        </td>
                                                        <td>
                                                            <mat-form-field class="example-full-width"
                                                                appearance="outline">
                                                                <mat-label class="lable_style2">Document Name
                                                                    :</mat-label>
                                                                <input type="text" readonly formControlName="UniDocName"
                                                                    matInput placeholder="Document Name">
                                                            </mat-form-field>
                                                        </td>
                                                        <td>
                                                            <mat-form-field class="example-full-width"
                                                                appearance="outline">
                                                                <mat-label class="lable_style2">Reference Number
                                                                    :</mat-label>
                                                                <input type="text" formControlName="UniDocRefNo"
                                                                    matInput maxlength="10" placeholder="Document Name">
                                                                <mat-error class="margin_tp sz float-left"
                                                                    *ngIf="TranscriptForm.controls['UniDocRefNo'].touched && TranscriptForm.controls['UniDocRefNo'].errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                            </mat-form-field>
                                                        </td>
                                                        <td>
                                                            <mat-form-field class="example-full-width"
                                                                appearance="outline">
                                                                <input type="text" readonly hidden matInput
                                                                    formControlName="UniDocUpload" />
                                                                <input type="file" id="i" placeholder="File"
                                                                    aria-label="File" accept=".pdf"
                                                                    formControlName="uniDocFile"
                                                                    (change)="onFileSelected($event)"
                                                                    onkeydown="return (event.keyCode!=13);"
                                                                    class="file-input" />
                                                                <mat-error class="margin_tp sz float-left"
                                                                    *ngIf="TranscriptForm.controls['UniDocUpload'].touched && TranscriptForm.controls['UniDocUpload'].errors?.required">
                                                                    Mandatory
                                                                </mat-error>

                                                            </mat-form-field>
                                                        </td>
                                                        <td (click)="showbase64new(TranscriptForm.get('UniDocUpload').value)"
                                                            *ngIf="DocView">
                                                            <a><label class="blue_col">View</label></a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>



                                        <!-- delivery option dropdown -->
                                        <div class="col-sm-3" >
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Delivery option </mat-label>
                                                        <mat-select  [disabled]="isdisabled" class="color" [placeholder]="'Delivery option'"
                                                            formControlName="DeliveryOpt">
                                                            <mat-option *ngFor="let item of deliveryList"
                                                                [value]="item.dropdownValue">
                                                                {{item.Value}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TranscriptForm.controls['DeliveryOpt'].touched && TranscriptForm.controls['DeliveryOpt'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3"
                                            *ngIf="TranscriptForm.get('DeliveryOpt').value === 'Soft' || TranscriptForm.get('DeliveryOpt').value === 'Both'">
                                            <div>
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Email Id </mat-label>
                                                            <input formControlName="EmailId" matInput
                                                                placeholder="Email Id" class="color">
                                                            <mat-error class="margin_tp sz float-left"
                                                                *ngIf="TranscriptForm.controls['EmailId'].touched && TranscriptForm.controls['EmailId'].errors?.required">
                                                                Mandatory
                                                            </mat-error>
                                                        </mat-form-field>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-2" *ngIf="TranscriptForm.get('ForeignUni').value == 'Y'">
                                            <div *ngIf="TranscriptForm.get('DeliveryOpt').value === 'Hard' || TranscriptForm.get('DeliveryOpt').value === 'Both'">
                                                <div class="form-group">
                                                    <div class="">
                                                        <section class="example-section mt-2">
                                                            <mat-checkbox class="example-margin "
                                                                formControlName="isSameAddr"
                                                                (change)="copyUniAddress($event)">Same as
                                                                above</mat-checkbox>
                                                        </section>
    
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-sm-3"
                                            *ngIf="TranscriptForm.get('DeliveryOpt').value === 'Hard' || TranscriptForm.get('DeliveryOpt').value === 'Both'">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Postal Address </mat-label>
                                                        <input [readonly]="isreadonly" formControlName="PostalAdd"
                                                            matInput placeholder="Postal Address" class="color">
                                                        <mat-error class="margin_tp sz float-left"
                                                            *ngIf="TranscriptForm.controls['PostalAdd'].touched && TranscriptForm.controls['PostalAdd'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Document Upload Table -->
                                        <hr class="mt-2 wd">
                                        <div>
                                            <p><strong>Documents To Upload</strong></p>
                                        </div>
                                        <div *ngIf="DocTable">
                                            <div class="table-responsive">
                                                <table id="datatable"
                                                    class="table tw table-bordered text-nowrap text-left">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th class="f600" style="width: 20%;">
                                                                Document Name
                                                            </th>
                                                            <th class="f600 " style="width: 20%;">
                                                                Document Upload
                                                            </th>
                                                            <th style="width: 10%;" *ngIf="DocView">
                                                                View
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="arrData">
                                                        <tr class="text-center" [formGroupName]="i"
                                                            *ngFor="let row of TranscriptForm.get('arrData')['controls']; let i = index; let last = last">
                                                            <td>
                                                                <mat-form-field class="example-full-width"
                                                                    appearance="outline">
                                                                    <mat-label class="lable_style2">Document Name
                                                                        :</mat-label>
                                                                    <input type="text" readonly
                                                                        formControlName="DocumentName" matInput
                                                                        placeholder="Document Name">
                                                                </mat-form-field>
                                                            </td>
                                                            <td>
                                                                <mat-form-field class="example-full-width"
                                                                    appearance="outline">
                                                                    <input type="text" readonly hidden matInput
                                                                        formControlName="DocumentFile" />
                                                                    <input type="file" id="i" placeholder="File"
                                                                        [accept]="row.get('DocumentName')?.value === 'Photo of student' ? '.png, .jpeg, .jpg' : '.pdf'"
                                                                        aria-label="File" formControlName="docFile"
                                                                        (change)="onChange($event, i)"
                                                                        onkeydown="return (event.keyCode!=13);"
                                                                        class="file-input" />

                                                                    <mat-error class="mt-1"
                                                                        *ngIf="row?.controls?.DocumentFile?.touched && row?.controls?.DocumentFile?.errors?.required">
                                                                        Mandatory
                                                                    </mat-error>
                                                                </mat-form-field>
                                                            </td>
                                                            <!-- <td *ngIf="isFileInputNot">
                                                                {{row.value.DocumentName}}
                                                            </td> -->
                                                            <td (click)="showbase64(row)" *ngIf="DocView">
                                                                <a><label class="blue_col">View</label></a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <!--  -->

                                    <button type="button"
                                        class="btn size btn-primary btn-icon-text floatright fr sz  mt-1"
                                        (click)="Back()">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/img/turn-left.gif"
                                                style="margin-right: 5px;">
                                            Back
                                        </span>
                                    </button>

                                    <button *ngIf="SaveBtn" type="button" (click)="Save()" [disabled]="SaveDisabled"
                                        class="btn btn-primary btn-icon-text floatright fr sz mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/images/save.gif"
                                                style="margin-right: 5px;">
                                            Save
                                        </span>
                                    </button>
                                    <button *ngIf="UpdateBtn" type="button" (click)="Update()"
                                        [disabled]="UpdateDisabled"
                                        class="btn btn-primary btn-icon-text floatright fr sz mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/images/save.gif"
                                                style="margin-right: 5px;">
                                            Update
                                        </span>
                                    </button>

                                    <button *ngIf="PayFee" type="button" (click)="PayFees()" [disabled]="PayDisabled"
                                        class="btn btn-primary btn-icon-text floatright fr mr-3 mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/images/pay-per-click.gif"
                                                style="margin-right: 5px;">
                                            Pay
                                        </span>
                                    </button>
                                    <button *ngIf="PayRecpt" type="button" (click)="getFeeTempData()"
                                        class="btn btn-primary pay btn-icon-text floatright fr mr-3 mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/images/pay-per-click.gif"
                                                style="margin-right: 5px;">
                                            Payment Receipt
                                        </span>
                                    </button>

                                    <div *ngIf="Table" class="table-responsive table-container tab mt-1">
                                        <table class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr class="text-left">

                                                    <th class="f600">
                                                        Id
                                                    </th>
                                                    <th class="f600">
                                                        Request Type
                                                    </th>
                                                    <th class="f600">
                                                        Course Name
                                                    </th>
                                                    <th *ngIf="CertStatus != 'ADMC'" class="f600">
                                                        Fee Status
                                                    </th>
                                                    <th class="f600">
                                                        Comment
                                                    </th>
                                                    <th class="f600">
                                                        Action
                                                    </th>
                                                    <th class="f600" *ngIf="AdminUpload.length > 0">
                                                        Certificate
                                                    </th>

                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let tclc of TclcData; let i = index">
                                                    <!-- <td *ngIf="ScrutinyTable.length > inteckCount" class="colorChnage" (click)="details(scrutiny)">
                                                            <a >{{scrutiny.StuFirstNameEng}}  {{ scrutiny.StuMidNameEng}}  {{ scrutiny.StuLastNameEng}}</a>
                                                        </td> -->

                                                    <td class="labelStyle">
                                                        {{tclc.TclcId}}
                                                    </td>
                                                    <td>
                                                        {{tclc.CertType == 'ADMC' ? 'Admission Cancellation' :
                                                        (tclc.CertType == 'TC' ? 'Transfer Certificate' : (tclc.CertType
                                                        == 'LC' ? 'Leaving Certificate' : (tclc.CertType == 'MC' ?
                                                        'Migration Certificate' : 'Transcript Certificate')))}}
                                                    </td>
                                                    <td>
                                                        {{tclc.CoName}}
                                                    </td>
                                                    <td *ngIf="tclc.CertType != 'ADMC'">
                                                        {{tclc.FeeStatus}}
                                                    </td>
                                                    <td>
                                                        {{tclc.Comment}}
                                                    </td>
                                                    <td>
                                                        {{Status}}
                                                    </td>
                                                    <td *ngIf="AdminUpload.length > 0">
                                                        <img alt="Logo" (click)="dowload()"
                                                            src="../../assets/images/arrow (1).png"
                                                            class="mh-45px curr pb-2">
                                                    </td>
                                                    <!-- <td>
                                                            <a class="btn-floating"
                                                            (click)="openModal(scrutiny)">
                                                            <i class="fa fa-eye"></i>
                                                        </a>
                                                        </td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>